import axiosInstance from "../AxiosInstance";

function apiRootBase() {
    const raw = process.env.REACT_APP_API_URL || "";
    return raw.replace(/\/+$/, "");
}

/**
 * Lista paginada de eventos de auditoría (DRF PageNumberPagination).
 * Las rutas viven fuera del prefijo `/api/` del axios por defecto.
 *
 * @param {string} mode - "purchase_order" | "bill"
 * @param {number|string} entityId
 * @param {number} [page=1]
 * @param {{ actions?: string[] }} [options] - Si actions está definido y no vacío, filtra en servidor (solo modo bill en backend).
 */
export async function fetchAuditEventsPage(mode, entityId, page = 1, options = {}) {
    const base = apiRootBase();
    const path =
        mode === "purchase_order"
            ? `v1/api/audits/purchase-order/${entityId}/`
            : `v1/api/audits/bill/${entityId}/`;

    const params = { page };
    const actions = Array.isArray(options.actions) ? options.actions.filter(Boolean) : [];
    if (actions.length) {
        params.actions = actions.join(",");
    }

    const { data } = await axiosInstance.get(path, {
        baseURL: base,
        params,
    });

    return {
        results: Array.isArray(data?.results) ? data.results : [],
        next: data?.next || null,
        count: typeof data?.count === "number" ? data.count : data?.results?.length ?? 0,
    };
}

const MAX_AUDIT_PAGES = 500;

/**
 * Recorre todas las páginas y devuelve la lista concatenada de resultados.
 */
export async function fetchAllAuditEvents(mode, entityId, options = {}) {
    const merged = [];
    let page = 1;
    while (page <= MAX_AUDIT_PAGES) {
        const { results, next } = await fetchAuditEventsPage(mode, entityId, page, options);
        merged.push(...results);
        if (!next) break;
        page += 1;
    }
    return merged;
}
